export default getText => key =>
  ({
    title: getText('Search a patient', 'Layout_Search'),
    firstnamePlaceholder: getText('patient firstname', 'Layout_Search'),
    lastnamePlaceholder: getText('patient lastname', 'Layout_Search'),
    datePlaceholder: getText('patient birthdate (dd-mm-yyyy)', 'Layout_Search'),
    ssnPlaceholder: getText('patient ssn', 'Layout_Search'),
  }[key])
